import { auth, db } from './apiClient';

/**
 * Logs a visit or event to the usage_metrics table.
 * @param {string} componentName - The name of the component/page (e.g., '5DD_Dashboard')
 * @param {object} [details={}] - Optional JSON details (e.g., { day: 1 })
 */
export const logVisit = async (componentName, details = {}) => {
  try {
    const session = await auth.getSession();
    const userId = session?.user?.id || null;

    await db.metrics.create({
      component: componentName,
      user_id: userId,
      details: details,
    });
  } catch (err) {
    console.warn('Analytics logging failed:', err.message || err);
  }
};
